import Advantages from './Advantages';
import AdvantagesSecond from './AdvantagesSecond';

export { Advantages, AdvantagesSecond };
